<script setup lang="ts">
import { computed } from 'vue'
import { ArrowRightFromBracketIcon } from 'Common/components/elements/icons/Icons'
import { useUserStore } from 'Store/userStore'

const userStore = useUserStore()
const firstLetterOfEmail = computed(() => userStore?.email[0]?.toUpperCase())

// event handler for clicking the log out button
const onLogout = async (): Promise<void> => {
  await userStore.logout()
}
</script>

<template>
  <el-popover
    v-if="userStore.isAuthenticated"
    width="250"
    trigger="click"
    placement="bottom"
    :show-arrow="false"
    popper-class="user-data-popper"
  >
    <div class="flex flex-col items-center justify-center">
      <div class="w-full flex items-center justify-center px-2 py-2 bg-blue-100">{{ userStore?.email }}</div>
      <div class="p-2 w-full">
        <el-button class="logout-button w-full" text size="large" @click="onLogout">
          <ArrowRightFromBracketIcon class="mr-2" />
          Log out
        </el-button>
      </div>
    </div>
    <template #reference>
      <el-button type="warning" circle>{{ firstLetterOfEmail }}</el-button>
    </template>
  </el-popover>
</template>

<style>
.el-popover.el-popper.user-data-popper {
  padding: 0;
}

.el-button.filter-button.is-text:not(.is-disabled):hover {
  background-color: darkgrey;
  color: white;
}

.el-button.filter-button.filter-on.is-text:not(.is-disabled) {
  background-color: darkgrey;
}

.logout-button span {
  width: 100%;
  align-items: self-start;
}
</style>
